export default "__VITE_ASSET__Cp_T8Q4F__"